export const content = `If for any reason you and your provider don't connect, you can rematch with another provider—no questions asked. Rematching with a new provider is simple.

## Rematching with a new therapist

1. From your dashboard, look for the section about **Your Care Team**.
2. Find your current therapist then select **Find A New Therapist**.
   ![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXdr3Rwk9Jdg3FchiBHT_Ko5VZkDy6QsWAlrwRcqLlSQ8BiJwxjdj-YmJrkIzdk8qdZlY5l7YUSdDGzlAoaQ1c7k6Qfecm2gZTTGQCkaDAwcrtms1OJI-nra1XiUmFvRWY4jziITAw?key=VtL8rUtxDsPjOX4EA8jD-Fpd)
3. Answer any questions, including adjusting any filters to refine your search.
4. Choose a therapist who better fits your needs and book your session.

## Rematching with a new psychiatric provider

To rematch with a new psychiatric provider, reach out to our support team. They can help you book sessions with a new provider who better matches your needs.

## Viewing your previous providers

After you’ve rematched with a new provider, you can still review any of your previous providers’ information.

1. From your dashboard, go to **Your Care Team** from your navigation bar.
2. Select **Show Archived Providers** to see the names of previous providers and your last session with them.
`;
